module.exports = "/static/assets/002ba0140d2bec1d251f56ae475c7832.png";